import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { db } from '../config/firebaseConfig';
import { getDocs, collection } from 'firebase/firestore';
import { Helmet } from 'react-helmet-async';
import Pagination from 'react-bootstrap/Pagination';

const Blog = () => {
  const [blogs, setBlogs] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [blogsPerPage] = useState(6);
  const [selectedCategory, setSelectedCategory] = useState('all'); // Seçili kategori
  const [categories, setCategories] = useState([]); // Kategori listesi

  useEffect(() => {
    const loadBlogs = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, 'blogs'));
        const blogList = [];

        querySnapshot.forEach((doc) => {
          const data = doc.data();

          let date = 'Unknown Date';
          if (data.createdAt && typeof data.createdAt.toDate === 'function') {
            date = data.createdAt.toDate().toLocaleDateString();
          } else if (data.createdAt) {
            const parsedDate = new Date(data.createdAt);
            if (!isNaN(parsedDate)) {
              date = parsedDate.toLocaleDateString();
            }
          }

          blogList.push({
            id: doc.id,
            title: data.title || 'Untitled Blog',
            description: data.description || 'No description available.',
            image: data.image || 'https://via.placeholder.com/300x200?text=No+Image',
            date: date,
            canonicalUrl: data.canonicalUrl || 'default-canonical-url',
            category: data.category || 'Genel', // Kategori alanı eklendi
          });
        });

        setBlogs(blogList);

        // Benzersiz kategorileri çıkar
        const uniqueCategories = ['all', ...new Set(blogList.map(blog => blog.category))];
        setCategories(uniqueCategories);
      } catch (error) {
        console.error('Error loading blogs:', error);
      }
    };

    loadBlogs();
  }, []);

  // Kategoriye göre filtrelenmiş bloglar
  const filteredBlogs = selectedCategory === 'all' 
    ? blogs 
    : blogs.filter(blog => blog.category === selectedCategory);

  // Sayfalama için blogları dilimleme
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = filteredBlogs.slice(indexOfFirstBlog, indexOfLastBlog);

  // Sayfa değiştirme fonksiyonu
  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  // Pagination öğelerini oluşturma
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredBlogs.length / blogsPerPage); i++) {
    pageNumbers.push(
      <Pagination.Item
        key={i}
        active={i === currentPage}
        onClick={() => paginate(i)}
      >
        {i}
      </Pagination.Item>
    );
  }

  return (
    <div className="container mt-4">
      <Helmet>
        <title>Blog Yazılarım | Teknoloji, Eğitim, Web Geliştirme ve Daha Fazlası</title>
        <meta
          name="description"
          content="Teknoloji, eğitim, web geliştirme, grafik tasarım ve dijital pazarlama gibi farklı kategorilerdeki yazılarımı keşfederek, ilgi alanlarınıza yönelik faydalı bilgiler edinebilirsiniz."
        />
      </Helmet>

      <div className="container section-title text-center mb-4">
        <h2>Blog Yazılarım</h2>
        <div className="title-shape">
          <svg viewBox="0 0 200 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M 0,10 C 40,0 60,20 100,10 C 140,0 160,20 200,10" fill="none" stroke="currentColor" strokeWidth="2"></path>
          </svg>
        </div>
        <p>
          Blog yazılarımda teknoloji, eğitim, web geliştirme ve daha fazlası hakkında bilgi edinebilirsiniz.
        </p>
      </div>

      {/* Kategori Sekmeleri */}
      <div className="mb-4 text-center">
        {categories.map((category) => (
          <button
            key={category}
            className={`btn ${selectedCategory === category ? 'btn-primary' : 'btn-outline-primary'} mx-1`}
            onClick={() => {
              setSelectedCategory(category);
              setCurrentPage(1); // Kategori değiştiğinde sayfayı sıfırla
            }}
          >
            {category === 'all' ? 'Tümü' : category}
          </button>
        ))}
      </div>

      <section className="row">
        {currentBlogs.length > 0 ? (
          currentBlogs.map((blog) => (
            <div key={blog.id} className="col-md-4 mb-4">
              <div className="card h-100">
                <img src={blog.image} className="card-img-top" alt={blog.title} />
                <div className="card-body">
                  <h5 className="card-title">{blog.title}</h5>
                  <p className="card-text">{blog.description}</p>
                  <div className="d-flex justify-content-between">
                    <time dateTime={blog.date}>{blog.date}</time>
                    <span>{blog.category}</span> {/* Kategori gösterimi */}
                  </div>
                  <Link
                    to={`/blog/${blog.canonicalUrl}`} // Düzeltildi: Tırnak işareti hatası
                    className="blogbutonu"
                  >
                    Daha Fazla
                  </Link>
                </div>
              </div>
            </div>
          ))
        ) : (
          <p>Bu kategoride henüz blog içeriği bulunmuyor.</p>
        )}
      </section>

      {/* Pagination */}
      <div className="d-flex justify-content-center mt-4">
        <Pagination>
          <Pagination.Prev
            onClick={() => setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev))}
            disabled={currentPage === 1}
          />
          {pageNumbers}
          <Pagination.Next
            onClick={() =>
              setCurrentPage((prev) =>
                prev < Math.ceil(filteredBlogs.length / blogsPerPage) ? prev + 1 : prev
              )
            }
            disabled={currentPage === Math.ceil(filteredBlogs.length / blogsPerPage)}
          />
        </Pagination>
      </div>
    </div>
  );
};

export default Blog;